import React, { useState, useEffect } from 'react';
import BlogList from '../components/Blog/BlogList';
import BlogPost from '../components/Blog/BlogPost';
import { useParams } from 'react-router-dom';
import BlogProgress from '../components/Blog/BlogProgress';
import { fetchBlogs } from '../DataLoader/blogs';
import BlogLoading from '../components/Blog/BlogLoading';
import '../styles/widths.css';


function Blog() {
  const { id } = useParams();
  const width = id ? 'w-full lg:w-[400px]' : 'w-full';
  const [activeSection, setActiveSection] = useState(0);
  const [visitedSections, setVisitedSections] = useState(new Set([0]));
  const [isProgressVisible, setIsProgressVisible] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sections, setSections] = useState([]);
  const [link, setLink] = useState(null);
  const [showScrollArrow, setShowScrollArrow] = useState(true);

  useEffect(() => {
    if (id) {
      const sectionsSetter = (data) => {
        const sections = data?.sections?.map((section, index) => ({
          title: section.sec_heading,
          id: `section-${index}`,
          subsections: section?.paragraphs?.filter(par => par.type === 'subheading').map((sub, i) => {
            return {
              title: sub.src,
              id: `section-${index}-${i}`
            }
          })
        })).filter(section => section.title) || [];
        setSections(sections);

        setBlog(data);
      }
      setLink(id);
      fetchBlogs(sectionsSetter, setLoading, setError, id);
    } else {
      setLink(null);
    }
  }, [id]);

  useEffect(() => {
    const blogsSetter = (data) => {
      setBlogs(data['titles']);
    }
    fetchBlogs(blogsSetter, () => {}, setError);
  }, []);

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const passedSections = [];

    sections.forEach((section, index) => {
      const el = document.getElementById(section.id);
      if (el) {
        const elementTop = el.offsetTop;
        const elementBottom = elementTop + el.offsetHeight;
        // Check if the element is currently in view
        if (scrollPosition >= elementTop && scrollPosition <= elementBottom) {
          passedSections.push(index);
        } else if (scrollPosition > elementBottom) {
          // Also track sections we've completely scrolled past
          passedSections.push(index);
        }
      }
    });

    const activeIndex = passedSections.length > 0
      ? Math.max(...passedSections)
      : 0;

    setActiveSection(activeIndex);
    setVisitedSections(new Set(passedSections));

    const footer = document.querySelector('footer');
    if (footer) {
      const footerTop = footer.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      setIsProgressVisible(footerTop > windowHeight);
    }
  };

  useEffect(() => {
    if (id) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [id]);

  useEffect(() => {
    const checkScrollableContent = () => {
      const blogListElement = document.querySelector('.blog-sidebar');
      if (!blogListElement) return;
      
      const hasScrollableContent = blogListElement.scrollHeight > blogListElement.clientHeight;
      const isNotAtBottom = blogListElement.scrollTop < (blogListElement.scrollHeight - blogListElement.clientHeight);
      
      setShowScrollArrow(hasScrollableContent && isNotAtBottom);
    };

    const blogListElement = document.querySelector('.blog-sidebar');
    if (blogListElement) {
      blogListElement.addEventListener('scroll', checkScrollableContent);
      // Initial check
      checkScrollableContent();
    }

    return () => {
      if (blogListElement) {
        blogListElement.removeEventListener('scroll', checkScrollableContent);
      }
    };
  }, [blogs, link]); // Re-run when blogs or link changes

  return (
    <div className='bg-white'>
      <div className='container mx-auto py-8 bg-white min-h-screen pt-[40px] xl:pt-[120px]'>
        <div className='flex flex-col lg:flex-row gap-4 justify-between'>
          {id && (
            <>
              <div className="w-[40px] relative hidden xl:inline">
                {/* <div className={`fixed xl:left-[30px] xxl:left-[calc(50%-720px)] top-1/2 -translate-y-1/2 z-10 transition-opacity duration-300 ${isProgressVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
                  }`}>
                  <BlogProgress
                    sections={sections}
                    activeSection={activeSection}
                    visitedSections={visitedSections}
                    onSectionClick={(index) => {
                      const section = sections[index];
                      document.getElementById(section.id)?.scrollIntoView({
                        behavior: 'smooth'
                      });
                    }}
                  />
                </div> */}
              </div>
              <div className="flex-1 max-w-[90%] sm:max-w-[360px] md:max-w-[720px] lg:max-w-[560px] xl:max-w-4xl mx-auto pt-[22px]">
                {loading ? <BlogLoading /> : <BlogPost post={blog} sections={sections} />}
              </div>
            </>
          )}
          <div className={`${width}`}>
            <div className={`sticky top-[150px] xl:top-[170px] ${id ? 'max-h-[calc(100vh-220px)] overflow-hidden' : ''}  `}>
              <div className={`flex justify-center blog-sidebar ${id ? 'no-scrollbar overflow-y-auto h-[calc(100vh-270px)]' : ' xl:gap-[150px]'}`}>
                <BlogList blogs={link ? blogs?.filter(blog => blog.id !== id) : blogs} />
              </div>
            {blogs?.length > 0 && (
              <div className="flex justify-center mt-4">
                <button
                  className="animate-bounce"
                  onClick={() => {
                    const blogListElement = document.querySelector('.blog-sidebar');
                    if (blogListElement) {
                      blogListElement.scrollBy({
                        top: 700,
                        behavior: 'smooth'
                      });
                    }
                  }}
                  style={{
                    display: showScrollArrow ? 'block' : 'none'
                  }}
                >
                  <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M26 2L14 14L2 2" stroke="#544A28" strokeWidth="3"/>
                  </svg>
                </button>
              </div>
            )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog; 